import { FC, useState, ChangeEvent, useEffect } from 'react';
import { useStyles } from './styles';
import { Grid, Paper, Tabs, Tab, IconButton } from '@material-ui/core';
import TabPanel from 'components/TabPanel';
import { OrganizationForm } from './SubForms';
import { useHistory } from 'react-router-dom';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import { handleCompanyUrl } from 'utils/organizationUtils';
function a11yProps(index: string) {
  return {
    id: `wrapped-tab-${index}`,
    'aria-controls': `wrapped-tabpanel-${index}`,
  };
}
export const DepartmentForm: FC<any> = ({ type }) => {
  const classes = useStyles();
  const history = useHistory();
  const [value, setValue] = useState<string>('one');
  const [currentDepartment, setCurrentDepartment] = useState<any>(() => {
    if (history.location.pathname.split('/')[3] === 'add') {
      localStorage.removeItem('CurrentDepartment');
      return null;
    }
    return JSON.parse(localStorage.getItem('CurrentDepartment') as string);
  });

  useEffect(() => {
    if (history.location.pathname.split('/')[3] !== 'add') {
      const timeoutId = setTimeout(() => {
        setCurrentDepartment(JSON.parse(localStorage.getItem('CurrentDepartment') as string));
      }, 3000);
      return () => clearTimeout(timeoutId);
    }
    return undefined;
  }, [history.location.pathname]);
  const handleChange = (event: ChangeEvent<unknown>, newValue: string) => {
    setValue(newValue);
  };
  return (
    <Grid item xl className={classes.tabsPanel}>
      <Paper className={classes.tabsPaper}>
        <div className={classes.left}>
          <IconButton
            onClick={() => {
              history.push(handleCompanyUrl('/departments'));
            }}
          >
            <ChevronLeftIcon />
          </IconButton>
          <Tabs
            value={value}
            indicatorColor='secondary'
            textColor='secondary'
            onChange={handleChange}
            className={classes.tabs}
          >
            <Tab
              value='one'
              label={currentDepartment?.ou ? `Department: ${currentDepartment.ou}` : 'DEPARTMENT'}
              {...a11yProps('one')}
              className={classes.label}
            />
          </Tabs>
        </div>
        <div className={classes.tabBox}>
          <TabPanel value={value} index='one'>
            <OrganizationForm type={type} currentDepartmeent={currentDepartment} />
          </TabPanel>
        </div>
      </Paper>
    </Grid>
  );
};
